import React, { FC, useCallback, useEffect } from 'react';
import { Image, ScrollView, TouchableOpacity, View } from 'react-native';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Text } from '../../../components/Text/Text';
import { homeStyles } from '../styles';
import { IS_WEB } from '../../../constants/platform';
import { addBase64Prefix } from '../../../services/addBase64Prefix';
import { notices } from '../../../assets/base64';
import { Button } from '../../../components/Button';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotices } from '../../../services/redux/reducers/ActionCreators';
import { RootState } from '../../../services/redux/store';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { COLORS, FONTS } from '../../../constants';
import {
  NoticeFilter,
  clearNoticeFilter,
  setLoadingNotice,
  setNotices,
} from '../../../services/redux/reducers/NoticeSlice';
import { NoticesApi } from '../../../services/api';
import { setTotal } from '../../../services/redux/reducers/EventSlice';
import { NavigationService } from '../../../services/navigation';
import TextTicker from 'react-native-text-ticker';

export const Notices: FC = () => {
  const dispatch: ThunkDispatch<RootState, void, AnyAction> = useDispatch();

  const isDesktop = useIsDesktop();
  const { noticesData } = useSelector(
    (state: RootState) => state?.noticeReducer
  );
  const dashboard = useSelector((state: RootState) => state?.dashboardReducer);

  const getNotices = useCallback(
    async (props: NoticeFilter) => {
      try {
        dispatch(setLoadingNotice(true));
        const res = await NoticesApi.getNotices(props);
        dispatch(setNotices(res.data.notices));
        dispatch(setTotal(res.data.total));
      } catch (error: any) {
        console.log(error);
      } finally {
        dispatch(setLoadingNotice(false));
      }
    },
    [dispatch]
  );

  useEffect(() => {
    dispatch(clearNoticeFilter());
    getNotices({});
  }, [dispatch, getNotices]);

  const latestNotice =
    dashboard.data.notices && dashboard.data.notices?.length > -0
      ? noticesData[0]
      : null;

  return (
    <>
      {dashboard.isLoading === false &&
      dashboard.data.notices &&
      dashboard.data.notices.length > 0 ? (
        <View
          style={[
            isDesktop() && { flexDirection: 'row', alignItems: 'center' },
            isDesktop() && homeStyles.noticesWeb,
          ]}
        >
          <View
            style={[homeStyles.notices, !isDesktop() && { marginBottom: 16 }]}
          >
            <TouchableOpacity
              onPress={() => {
                NavigationService.push<'Root'>('Root', {
                  screen: 'MenuTab',
                  params: {
                    screen: 'Notices',
                    params: {
                      screen: 'new',
                    },
                  },
                });
              }}
            >
              <Image
                source={require('../../../assets/notices.png')}
                style={{
                  width: 22,
                  height: 22,
                  tintColor: STYLE_VARS.primaryColor,
                  resizeMode: 'contain',
                  marginRight: 5,
                }}
              />
            </TouchableOpacity>
            {isDesktop() && (
              <Text
                style={{
                  fontSize: 22,
                  fontFamily: FONTS.IowanOldStyleBTRoman,
                  color: STYLE_VARS.primaryColor,
                  marginRight: 20,
                }}
                onPress={() => {
                  NavigationService.push<'Root'>('Root', {
                    screen: 'MenuTab',
                    params: {
                      screen: 'Notices',
                      params: {
                        screen: 'new',
                      },
                    },
                  });
                }}
              >
                NOTICES
              </Text>
            )}

            {!isDesktop() && (
              <Text
                style={{
                  fontSize: 18,
                  fontFamily: FONTS.IowanOldStyleBTRoman,
                  color: STYLE_VARS.primaryColor,
                  alignSelf: 'center',
                  marginLeft: 5,
                  marginRight: 20,
                }}
                onPress={() => {
                  NavigationService.push<'Root'>('Root', {
                    screen: 'MenuTab',
                    params: {
                      screen: 'Notices',
                      params: {
                        screen: 'new',
                      },
                    },
                  });
                }}
              >
                NOTICES
              </Text>
            )}
            {IS_WEB ? (
              <ScrollView
                horizontal={true}
                showsHorizontalScrollIndicator={false}
              >
                <Text
                  numberOfLines={1}
                  style={{ flex: 1, fontSize: 13 }}
                  onPress={() => {
                    if (latestNotice) {
                      NavigationService.push<'NoticeDetail'>('NoticeDetail', {
                        id: latestNotice.id,
                      });
                    }
                  }}
                >
                  {latestNotice?.title.toUpperCase()}
                </Text>
              </ScrollView>
            ) : (
              <View style={{ marginEnd: 50 }}>
                {/* Disable on website */}
                {/* <TextTicker
                  style={{ flex: 1, fontSize: 13, color: COLORS.DARKER_GREY }}
                  duration={3000}
                  loop={true}
                  repeatSpacer={50}
                  bounce={false}
                  marqueeDelay={1000}
                  scrollSpeed={50}
                  onPress={() => {
                    if (latestNotice) {
                      NavigationService.push<'NoticeDetail'>('NoticeDetail', {
                        id: latestNotice.id,
                      });
                    }
                  }}
                >
                  {latestNotice?.title.toUpperCase()}
                </TextTicker> */}
              </View>
            )}
          </View>
        </View>
      ) : (
        <View>
          {dashboard.isLoading === true && (
            <Text
              style={{
                fontSize: 22,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                color: STYLE_VARS.primaryColor,
                marginBottom: 16,
                marginTop: 20,
              }}
            >
              {'LOADING...'}
            </Text>
          )}
        </View>
      )}
    </>
  );
};
